/* Mega menu panel height (2026-11-04): each panel keeps its own natural height, and the bottom
   edge SLIDES between heights as the pointer flicks between menus instead of jumping. When a
   panel opens (its <details> gains .is-open) its content height is measured (scrollHeight, so
   the current fixed height doesn't matter) and written to --mega-height on <main-menu>; the
   rule in assets/custom.css gives every mega panel height: var(--mega-height) with a short
   transition, so the closing panel and the opening one move to the new height together.
   Equal heights for all panels was tried first and padded the small menus out. */
(function () {
  var mq = window.matchMedia('(min-width: 769px)');
  var menu = document.querySelector('main-menu');
  if (!menu || !('MutationObserver' in window)) return;
  function setFor(details) {
    if (!mq.matches) { menu.style.removeProperty('--mega-height'); return; }
    var panel = details.querySelector(':scope > .main-nav__child.mega-nav');
    if (!panel) return;
    var h = panel.scrollHeight;
    if (h > 0) menu.style.setProperty('--mega-height', h + 'px');
  }
  var mo = new MutationObserver(function (records) {
    records.forEach(function (r) {
      var el = r.target;
      if (el.tagName === 'DETAILS' && el.classList.contains('is-open') && !el.classList.contains('is-closing')) setFor(el);
    });
  });
  mo.observe(menu, { attributes: true, attributeFilter: ['class'], subtree: true });
  window.addEventListener('resize', function () { if (!mq.matches) menu.style.removeProperty('--mega-height'); });
})();
